import React from 'react';
import PropTypes from 'prop-types';
import { useApiClient } from '../../../../context/ApiClientContext';
import ModuleCreateForm from '../../../Module/ModuleCreateForm';

export default function MakeThisAModuleForm(props) {
  const { actionListId, onSuccess } = props;

  const apiClient = useApiClient();

  return (
    <ModuleCreateForm
      onSubmit={(values) => apiClient.reassignActionListToANewModule(
        actionListId,
        values.moduleName,
      )}
      onSuccess={onSuccess}
    />
  );
}

MakeThisAModuleForm.propTypes = {
  actionListId: PropTypes.number.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
